import { ApplicationRef, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injector, OnInit } from '@angular/core';
import { GlobalConstantsSonstige, GlobalService } from 'globales-projekt-angular';
import { Guid } from 'guid-typescript'; 
import { FilterWertRow } from 'src/app/data/klassen/filter-wert-row.model';
import { ModulPrWertFilter } from 'src/app/data/ws/modul/modul-pr-wert-filter.model';
import { FilterWertTabelleComponent } from '../filter-wert-tabelle/filter-wert-tabelle.component';
import { AuswahlComponent } from 'src/app/components/pages/anwendung/auswahl/auswahl.component';

@Component({
  selector: 'app-filter-wert-row',
  templateUrl: './filter-wert-row.component.html',
  styleUrls: ['./filter-wert-row.component.css']
})
export class FilterWertRowComponent implements OnInit {
  filterWertRow!: FilterWertRow;

  public parentMainComponent!: AuswahlComponent;
  
  id!: Guid;

  childGuidFilterWertTabelle: Guid[] = [];
  childRefFilterWertTabelle: ComponentRef<FilterWertTabelleComponent>[] = [];

  constructor( 
    private cfr: ComponentFactoryResolver,
    public globalService: GlobalService,
    private injector: Injector,
    private appRef: ApplicationRef) { }

  ngOnInit(): void {
    
  }

  setVariablen(filterWertRow: FilterWertRow) { 
    this.filterWertRow = filterWertRow;
  }

  createSubTables()
  { 
 
    if (this.filterWertRow.modulPrWertFilterLinks)
      this.createSubTable(this.filterWertRow.modulPrWertFilterLinks, GlobalConstantsSonstige.DOM_CONTENT_DATEN_9);
    if (this.filterWertRow.modulPrWertFilterRechts)
      this.createSubTable(this.filterWertRow.modulPrWertFilterRechts, GlobalConstantsSonstige.DOM_CONTENT_DATEN_10);
    
  }

  createSubTable(modulPrWertFilter: ModulPrWertFilter, domElement: string) {
    // Erstelle die Komponente
    let filterDatentabelle: ComponentFactory<FilterWertTabelleComponent> =
      this.cfr.resolveComponentFactory(FilterWertTabelleComponent);
    let componentRef: ComponentRef<FilterWertTabelleComponent> =
    filterDatentabelle.create(this.injector);

    // Setze Werte und füge die Komponente zur DOM hinzu
    let id: Guid = Guid.create();
    this.childGuidFilterWertTabelle.unshift(id);

    componentRef.instance.id = id;
    componentRef.instance.parentMainComponent = this;
    componentRef.instance.setVariablen(modulPrWertFilter);

    this.childRefFilterWertTabelle.unshift(componentRef);

    this.appRef.attachView(componentRef.hostView);
    let domElem: Node = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

   
    // Finde das Ziel-DOM-Element und ersetze es durch die neue Komponente
    let targetElement = document.getElementById(domElement);
    if (targetElement) {
      targetElement.removeAttribute('id'); // TODO in Globales Projekt verschieben
      targetElement.appendChild(domElem);
    }
  }
}
